
import { Options, Vue } from "vue-class-component";
import SideMenu from "@/components/WorkBench/SideMenu.vue";

@Options({
  components: {
    SideMenu,
  },
})
export default class AccountManage extends Vue {}
